import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al0005',
    ecrans: ['00-2'],
    params: ['?eplnummat']
});
